import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { FUTURE_ORDER_LIMIT } from '@silvergatedelivery/constants';

export default function SubsidyDateTimeSetting({
  mealItem,
  onUpdate,
  mealIndex,
}) {
  const [isEnabled, setIsEnabled] = useState(!!(mealItem.subsidyDayOffset || mealItem.subsidyTime));

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsEnabled(checked);

    if (checked) {
      const newMealItem = {
        ...mealItem,
        subsidyDayOffset: mealItem.subsidyDayOffset || 1,
        subsidyTime: mealItem.subsidyTime || '12:00',
      };
      onUpdate(newMealItem);
    } else {
      const newMealItem = { ...mealItem };
      delete newMealItem.subsidyDayOffset;
      delete newMealItem.subsidyTime;
      onUpdate(newMealItem);
    }
  };

  const handleSubsidyDayOffsetChange = (event) => {
    const newMealItem = {
      ...mealItem,
      subsidyDayOffset: event.target.value,
    };
    onUpdate(newMealItem);
  };

  const handleSubsidyTimeChange = (event) => {
    const newMealItem = {
      ...mealItem,
      subsidyTime: event.target.value,
    };
    onUpdate(newMealItem);
  };

  return (
    <Grid container spacing={2} style={{ marginBottom: 16 }} alignItems="center">
      <Grid item md={4}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isEnabled}
              onChange={handleCheckboxChange}
              color="primary"
            />
          }
          label={mealIndex !== undefined ? `設定餐點${mealIndex + 1}的核銷日期與時間` : '設定此餐點的核銷日期與時間'}
        />
      </Grid>
      {isEnabled && (
        <>
          <Grid item md={3}>
            <FormControl fullWidth>
              <InputLabel id="subsidy-day-offset-label">核銷日期</InputLabel>
              <Select
                labelId="subsidy-day-offset-label"
                value={mealItem.subsidyDayOffset || 1}
                onChange={handleSubsidyDayOffsetChange}
              >
                {Array.from({ length: FUTURE_ORDER_LIMIT }, (_, i) => (
                  <MenuItem key={i} value={i + 1}>{i + 1}天後</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={3}>
            <TextField
              fullWidth
              type="time"
              label="核銷時間"
              value={mealItem.subsidyTime || '12:00'}
              onChange={handleSubsidyTimeChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}

SubsidyDateTimeSetting.propTypes = {
  mealItem: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired,
  mealIndex: PropTypes.number.isRequired,
};
